/**
 * Диалог выбора действия для админа при сканировании QR-кода
 */
import './AdminActionDialog.css'

export interface AdminActionDialogProps {
  employeeName: string
  onCheckIn: () => void
  onOpenAdminPanel: () => void
  onClose: () => void
}

export function AdminActionDialog({ 
  employeeName, 
  onCheckIn, 
  onOpenAdminPanel, 
  onClose 
}: AdminActionDialogProps) {
  return (
    <div className="admin-action-dialog-overlay" onClick={onClose}>
      <div className="admin-action-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="admin-action-dialog-header">
          <h2>👋 Здравствуйте, {employeeName}!</h2>
          <button className="close-button" onClick={onClose} aria-label="Закрыть">
            ×
          </button>
        </div>
        
        <p className="admin-action-dialog-subtitle">Выберите действие:</p>
        
        <div className="admin-action-dialog-buttons">
          <button 
            className="admin-action-button check-in-button"
            onClick={onCheckIn}
          >
            <span className="button-icon">📍</span>
            <span className="button-text">Отметиться</span>
          </button>
          
          <button 
            className="admin-action-button admin-panel-button"
            onClick={onOpenAdminPanel}
          >
            <span className="button-icon">⚙️</span>
            <span className="button-text">Админ-панель</span>
          </button>
        </div>
      </div>
    </div>
  )
}

